<template>
  <div class="msf" :style="containerStyle">
    <div class="msf__chips" v-if="modelValue && modelValue.length">
      <span v-for="key in modelValue" :key="String(key)" class="msf__chip">
        <span class="msf__chip-text">{{ labelByKey(key) }}</span>
        <button type="button" class="msf__chip-del" @click="$emit('update:modelValue', removeKey(key))" :aria-label="$t('common.delete')">×</button>
      </span>
    </div>

    <SelectField
      :options="normalizedOptionsFiltered"
      :model-value="null"
      :placeholder="$t('common.add') + '...'"
      :searchable="true"
      :width="width"
      @update:modelValue="onPick"
    />
  </div>
</template>

<script>
import SelectField from '@/components/widgets/SelectField.vue'

export default {
  name: 'MultiSelectField',
  components: { SelectField },
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: Array, default: () => [] },
    options: { type: Array, required: true },
    width: { type: [String, Number], default: null },
  },
  computed: {
    normalizedOptions() {
      return (this.options || []).map(o => ({ value: o.key, label: String(o.label || ''), key: o.key }))
    },
    normalizedOptionsFiltered() {
      const set = new Set(this.modelValue || [])
      return this.normalizedOptions.filter(o => !set.has(o.key))
    },
    containerStyle() {
      if (!this.width) return {};
      const w = typeof this.width === 'number' ? `${this.width}px` : this.width;
      return { width: w };
    },
  },
  methods: {
    labelByKey(key) {
      return this.options.find(o => o.key === key)?.label || String(key)
    },
    onPick(val) {
      if (val == null) return
      const set = new Set(this.modelValue || [])
      set.add(val)
      this.$emit('update:modelValue', [...set])
    },
    removeKey(key) {
      const out = (this.modelValue || []).filter(k => k !== key)
      return out
    },
  }
}
</script>

<style scoped>
.msf { display: grid; gap: 8px; width: 75%; }
.msf__chips { display: flex; flex-wrap: wrap; gap: 6px; }
.msf__chip { display: inline-flex; align-items: center; gap: 6px; padding: 4px 8px; border-radius: 999px; background: #F3F4F6; color: #111827; font-size: 16px; }
.msf__chip-del { border: 0; background: transparent; cursor: pointer; font-weight: 700; color: #6B7280; }
.msf__chip-del:hover { color: #111827; }
</style>

